import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';
import { url } from 'utils/url';
import { log } from 'utils';
import Axios from 'axios';

const baseUrl = url;
export const WEB_CONTENTS_FETCH = createAction('WEB_CONTENTS_FETCH');
export const WEB_CONTENTS_FETCH_DATA_SUCCESS = createAction(
  'WEB_CONTENTS_FETCH_DATA_SUCCESS'
);
export const WEB_CONTENTS_FETCH_DATA_FAIL = createAction(
  'WEB_CONTENTS_FETCH_DATA_FAIL'
);

export const WEB_CONTENTS_DELETE_INIT = createAction(
  'WEB_CONTENTS_DELETE_INIT'
);
export const WEB_CONTENTS_DELETE_SUCCESS = createAction(
  'WEB_CONTENTS_DELETE_SUCCESS'
);
export const WEB_CONTENTS_DELETE_FAIL = createAction(
  'WEB_CONTENTS_DELETE_FAIL'
);

export const WEB_CONTENTS_CLEAR_DATA = createAction('WEB_CONTENTS_CLEAR_DATA');

export const WEB_CONTENTS_CREATE_INIT = createAction(
  'WEB_CONTENTS_CREATE_INIT'
);
export const WEB_CONTENTS_CREATE_SUCCESS = createAction(
  'WEB_CONTENTS_CREATE_SUCCESS'
);
export const WEB_CONTENTS_CREATE_FAIL = createAction(
  'WEB_CONTENTS_CREATE_FAIL'
);

export const WEB_CONTENTS_MODIFY_INIT = createAction(
  'WEB_CONTENTS_MODIFY_INIT'
);
export const WEB_CONTENTS_MODIFY_SUCCESS = createAction(
  'WEB_CONTENTS_MODIFY_SUCCESS'
);
export const WEB_CONTENTS_MODIFY_FAIL = createAction(
  'WEB_CONTENTS_MODIFY_FAIL'
);

export const WEB_CONTENTS_CLEAN_UP = createAction('WEB_CONTENTS_CLEAN_UP');

export const WEB_CONTENTS_CLEAR_DATA_LOGOUT = createAction(
  'WEB_CONTENTS_CLEAR_DATA_LOGOUT'
);
export const WEB_CONTENTS_BULK = createAction('WEB_CONTENTS_BULK');

export const SET_WEB_CONTENTS = createAction('SET_WEB_CONTENTS');

export const fetchWebContents = () => {
  return async (dispatch, getState) => {
    dispatch(WEB_CONTENTS_FETCH());
    let webContentsData;
    try {
      webContentsData = await Axios.get(`${baseUrl}/webContents/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_CONTENTS_FETCH_DATA_FAIL({ error }));
    }
    const WEB_CONTENTS = { ...webContentsData.data };
    return dispatch(
      WEB_CONTENTS_FETCH_DATA_SUCCESS({
        list: getState().webContents.list,
        WEB_CONTENTS,
      })
    );
  };
};

export const addWebContents = (payload) => {
  return async (dispatch, getState) => {
    dispatch(WEB_CONTENTS_FETCH());
    let webContentsData;
    console.log('sini');
    try {
      webContentsData = await Axios.post(
        `${baseUrl}/webContents/create`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_CONTENTS_CREATE_FAIL({ error }));
    }
    return dispatch(WEB_CONTENTS_CREATE_SUCCESS());
  };
};

export const updateWebContents = (id, payload) => {
  return async (dispatch, getState) => {
    dispatch(WEB_CONTENTS_FETCH());
    try {
      webContentsData = await Axios.put(
        `${baseUrl}/webContents/${id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_CONTENTS_CREATE_FAIL({ error }));
    }
    return dispatch(WEB_CONTENTS_CREATE_SUCCESS());
  };
};

export const deleteWebContents = (id) => {
  return async (dispatch, getState) => {
    dispatch(WEB_CONTENTS_FETCH());
    try {
      webContentsData = await Axios.delete(`${baseUrl}/webContents/${id.id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(WEB_CONTENTS_CREATE_FAIL({ error }));
    }
    return dispatch(WEB_CONTENTS_CREATE_SUCCESS());
  };
};
